<i18n
  src="@/locales/views/agro_exporter/quality_reports/container/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_reports_container_provider_list_processes_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, agro_exporter_process.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :agro_exporter_id="agro_exporter_id"
      :agro_exporter_process_id="agro_exporter_process_id"
      :rejected_series="rejected_series"
      :weeks="weeks"
      :providers="providers"
      :defect_series="defect_series"
      :defects="defects"
    ></router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_reports/container_provider/show_process.js";

export default {
  name: "AEQualityReportsContainerProviderShowProcess",
  props: ["agro_exporter_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      rejected_series: [],
      defect_series: [],
      defects: [],
      weeks: [],
      providers: [{id: null, name: "Todos"}],
      option_tabs: [],
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
      this.providers.push(...response.data.agro_exporter_providers);
    },

    fetchRejectedPercentage: async function () {
      let response = await Requester.fetchRejectedPercentage(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.rejected_series = response.data.provider_series;
      this.weeks = response.data.weeks;

      this.load_data_general = true;
    },

    fetchTopDefects: async function (provider_id = null) {
      let response = await Requester.fetchTopDefects(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        provider_id
      );
      this.defects = response.data.defects;
      this.defect_series = response.data.provider_series;
    },

    fillOptions: function() {
      this.option_tabs = [
        {
          name: "Resumen",
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") },
        },
        {
          name: "Gráficos",
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_process_graphics") },
        },
        {
          name: "Data",
          icon: "fa-solid fa-table",
          route: { name: this.routeName("show_process_data") },
        },
        {
          name: "Análisis Trimestral",
          icon: "fa-solid fa-calendar-alt",
          route: { name: this.routeName("show_process_quarterly_analysis") },
        },
      ]
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fillOptions();
        this.fetchAgroExporterProcess();
        this.fetchRejectedPercentage();
        this.fetchTopDefects();
      })
    );
  },
};
</script>
